import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssetType } from '../../enums/asset-type.enum';

export interface MediaPreviewItem {
  url: string;
}

@Component({
  selector: 'dal-shared-ui-assetpreview',
  templateUrl: './assetpreview.component.html',
  styleUrl: './assetpreview.component.scss',
})
export class AssetpreviewComponent implements OnInit {
  @Input() mediaFiles: MediaPreviewItem[] = [];
  @Input() assetTypeId: number = 0;
  showCloseButton = false;
  url: string = '';
  assetType: number;

constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      // Only overwrite @Input() values when the params are actually present in
      // the URL. On embedded routes (e.g. edit/:id) there is no ?imageUrl or
      // ?assetType, so params.get() returns null and @Input() is left intact.
      const imageUrl = params.get('imageUrl');
      const assetType = params.get('assetType');
      if (imageUrl !== null) {
        this.url = imageUrl;
      }
      if (assetType !== null) {
        this.assetTypeId = parseInt(assetType, 10);
      }
    });
  }

  getMediaType(): string {
    switch (this.assetTypeId) {
      case 1:
        return AssetType[1].toLowerCase();
      case 2:
        return AssetType[2].toLowerCase();
      case 3:
        return AssetType[3].toLowerCase();
      case 4:
        return AssetType[4].toLowerCase();
      default:
        return AssetType[5].toLowerCase();
    }
  }

  openImageInNewTab(url: string | undefined): void {
    if (!url) {
      return;
    }
    window.open(`/preview?imageUrl=${encodeURIComponent(url)}&assetType=${this.assetTypeId}`, '_blank');
  }

  isPreviewOpen: boolean = false;

  openPreview() {
    this.isPreviewOpen = true;
  }

  closePreview() {
    this.isPreviewOpen = false;
    window.close();
  }

}
